import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChatCircleText, GoogleLogo } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LoginPage = () => {
  const navigate = useNavigate();

  // Check if already authenticated
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${API}/auth/me`, {
          credentials: 'include'
        });
        if (response.ok) {
          navigate('/');
        }
      } catch (error) {
        // Not authenticated, stay on login page
      }
    };
    checkAuth();
  }, [navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-slate-50 flex flex-col">
      {/* Header */}
      <header className="p-6">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl bg-indigo-700 flex items-center justify-center">
            <ChatCircleText className="w-6 h-6 text-white" weight="duotone" />
          </div>
          <span 
            className="text-xl font-bold text-slate-900"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            GardinBot
          </span>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8">
            <div className="text-center mb-8">
              <h1 
                className="text-3xl font-bold text-slate-900 mb-2"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Velkommen tilbage
              </h1>
              <p className="text-slate-600">
                Log ind for at administrere din AI kundeservice
              </p>
            </div>

            <Button
              onClick={handleGoogleLogin}
              className="w-full h-12 bg-white border-2 border-slate-200 text-slate-700 hover:bg-slate-50 hover:border-slate-300 font-medium rounded-xl transition-all"
              data-testid="google-login-btn"
            >
              <GoogleLogo className="w-5 h-5 mr-3" weight="bold" />
              Fortsæt med Google
            </Button>

            <div className="mt-6 text-center">
              <p className="text-sm text-slate-500">
                Kun brugere med <span className="font-medium text-slate-700">@gardinbussen.org</span> email kan logge ind
              </p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-slate-500">
              AI-drevet kundeservice til gardinshoppen.dk
            </p>
          </div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="p-6 text-center">
        <p className="text-sm text-slate-400">
          &copy; {new Date().getFullYear()} GardinBussen. Alle rettigheder forbeholdes.
        </p>
      </footer>
    </div>
  );
};
